import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
    },
    {
      path: "/",
      component: () => import("../components/Home.vue"),
      meta: { title: "home" },
      children: [
        {
          path: "dashboard",
          component: () => import("../pages/dashboard"),
          meta: { 
            title: {
              'zh-CN': '工作台',
              'zh-TW': '工作台',
              'en': 'Dashboard'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "managementAccounts",
          component: () => import("../pages/dashboard/managementAccounts"),
          meta: { 
            title: {
              'zh-CN': '账户管理',
              'zh-TW': '賬戶管理',
              'en': 'Account Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "customerInput",
          component: () => import("../pages/customer/customerInput.vue"),
          meta: { 
            title: {
              'zh-CN': '客户录入',
              'zh-TW': '客戶錄入',
              'en': 'Customer Input'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "customerManagement",
          component: () => import("../pages/customer/customerManagement.vue"),
          meta: { 
            title: {
              'zh-CN': '客户管理',
              'zh-TW': '客戶管理',
              'en': 'Customer Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "customerDetall",
          component: () => import("../pages/customer/customerDetall.vue"),
          meta: { 
            title: {
              'zh-CN': '客户详情',
              'zh-TW': '客戶詳情',
              'en': 'Customer Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "afterSalesDetall",
          component: () => import("../pages/customer/afterSalesDetall.vue"),
          meta: { 
            title: {
              'zh-CN': '售后详情',
              'zh-TW': '售後詳情',
              'en': 'After-Sales Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "totalCustomer",
          component: () => import("../pages/customer/totalCustomer.vue"),
          meta: { 
            title: {
              'zh-CN': '总客户池',
              'zh-TW': '總客戶池',
              'en': 'Total Customer Pool'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "returnVisit",
          component: () => import("../pages/customer/returnVisit.vue"),
          meta: { 
            title: {
              'zh-CN': '待回访区',
              'zh-TW': '待回訪區',
              'en': 'Return Visit Area'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "returnVisit",
          component: () => import("../pages/customer/returnVisit.vue"),
          meta: { title: "客户跟进分析", keepAlive: false },
        },
        {
          path: "returnVisit",
          component: () => import("../pages/customer/returnVisit.vue"),
          meta: { title: "客户跟进分析", keepAlive: false },
        },
        {
          path: "memberReturnVisit",
          component: () => import("../pages/customer/memberReturnVisit.vue"),
          meta: { 
            title: {
              'zh-CN': '成员客户跟进分析',
              'zh-TW': '成員客戶跟進分析',
              'en': 'Member Customer Follow-up Analysis'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "followUpAnalyse",
          component: () => import("../pages/customer/followUpAnalyse.vue"),
          meta: { 
            title: {
              'zh-CN': '客户跟进分析',
              'zh-TW': '客戶跟進分析',
              'en': 'Customer Follow-up Analysis'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "corporateInformation",
          component: () =>
            import("../pages/businessManagement/corporateInformation"),
          meta: { 
            title: {
              'zh-CN': '企业信息',
              'zh-TW': '企業信息',
              'en': 'Company Information'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "enterpriseMember",
          component: () =>
            import("../pages/businessManagement/enterpriseMember"),
          meta: { 
            title: {
              'zh-CN': '企业成员',
              'zh-TW': '企業成員',
              'en': 'Enterprise Members'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "memberDetall",
          component: () => import("../pages/businessManagement/memberDetall"),
          meta: { 
            title: {
              'zh-CN': '成员详情',
              'zh-TW': '成員詳情',
              'en': 'Member Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "sectorSetup",
          component: () =>
            import("../pages/businessManagement/sectorSetup/sectorSetup"),
          meta: { 
            title: {
              'zh-CN': '部门设置',
              'zh-TW': '部門設置',
              'en': 'Department Settings'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "AdministratorList",
          component: () =>
            import(
              "../pages/businessManagement/AdministratorList/AdministratorList"
            ),
          meta: { 
            title: {
              'zh-CN': '管理员列表',
              'zh-TW': '管理員列表',
              'en': 'Administrator List'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "AdministratorDetail",
          component: () =>
            import(
              "../pages/businessManagement/AdministratorList/AdministratorDetail"
            ),
          meta: { 
            title: {
              'zh-CN': '管理员设置',
              'zh-TW': '管理員設置',
              'en': 'Administrator Settings'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "WeChatClient",
          component: () => import("../pages/businessManagement/WeChatClient"),
          meta: { 
            title: {
              'zh-CN': '客户企微数据',
              'zh-TW': '客戶企微數據',
              'en': 'Customer WeChat Data'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "launchProducts",
          component: () =>
            import("../pages/merchandiseManagement/appointment/management"),
          meta: { 
            title: {
              'zh-CN': '发布产品',
              'zh-TW': '發布產品',
              'en': 'Launch Products'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "advancedForm",
          component: () => import("../pages/businessManagement/advancedForm"),
          meta: { 
            title: {
              'zh-CN': '高级表单',
              'zh-TW': '高級表單',
              'en': 'Advanced Form'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "performanceAssessment",
          component: () =>
            import("../pages/businessManagement/performanceAssessment"),
          meta: { 
            title: {
              'zh-CN': '企业成员审核',
              'zh-TW': '企業成員審核',
              'en': 'Enterprise Member Review'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "theInspectionRules",
          component: () =>
            import("../pages/businessManagement/theInspectionRules"),
          meta: { 
            title: {
              'zh-CN': '考核规则',
              'zh-TW': '考核規則',
              'en': 'Assessment Rules'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "theAssessmentDetails",
          component: () =>
            import("../pages/businessManagement/theAssessmentDetails"),
          meta: { 
            title: {
              'zh-CN': '考核详情',
              'zh-TW': '考核詳情',
              'en': 'Assessment Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "publishAdvancedForm",
          name: "publishAdvancedForm",
          component: () =>
            import("../pages/businessManagement/publishAdvancedForm"),
          meta: { 
            title: {
              'zh-CN': '新增表单',
              'zh-TW': '新增表單',
              'en': 'Add New Form'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "formDetall",
          name: "formDetall",
          component: () => import("../pages/businessManagement/formDetall"),
          meta: { 
            title: {
              'zh-CN': '表单详情',
              'zh-TW': '表單詳情',
              'en': 'Form Details'
            }, 
            keepAlive: false 
          },
        },
  
        {
          path: "advertisingManagement",
          component: () =>
            import("../pages/businessManagement/advertisingManagement"),
          meta: { 
            title: {
              'zh-CN': '广告图管理',
              'zh-TW': '廣告圖管理',
              'en': 'Advertising Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "setBanner",
          component: () => import("../pages/businessManagement/setBanner"),
          meta: { 
            title: {
              'zh-CN': '广告图设置',
              'zh-TW': '廣告圖設置',
              'en': 'Banner Settings'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "orderManagement",
          component: () => import("../pages/orderManagement"),
          meta: { 
            title: {
              'zh-CN': '订单管理',
              'zh-TW': '訂單管理',
              'en': 'Order Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "financialStatistics",
          component: () =>
            import("../pages/financialManagement/financialStatistics"),
          meta: { 
            title: {
              'zh-CN': '财务统计',
              'zh-TW': '財務統計',
              'en': 'Financial Statistics'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "moneyRecord",
          component: () => import("../pages/financialManagement/moneyRecord"),
          meta: { 
            title: {
              'zh-CN': '资金记录',
              'zh-TW': '資金記錄',
              'en': 'Money Records'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "WithdrawalRecord",
          component: () =>
            import("../pages/financialManagement/WithdrawalRecord"),
          meta: { 
            title: {
              'zh-CN': '提现记录',
              'zh-TW': '提現記錄',
              'en': 'Withdrawal Records'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "commissionManagement",
          component: () =>
            import("../pages/financialManagement/commissionManagement"),
          meta: { 
            title: {
              'zh-CN': '佣金管理',
              'zh-TW': '佣金管理',
              'en': 'Commission Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "accountManagement",
          component: () =>
            import("../pages/financialManagement/accountManagement"),
          meta: { 
            title: {
              'zh-CN': '账户管理',
              'zh-TW': '賬戶管理',
              'en': 'Account Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "creditRecordManagement",
          component: () =>
            import("../pages/financialManagement/creditRecordManagement"),
          meta: { 
            title: {
              'zh-CN': '信用额度记录',
              'zh-TW': '信用額度記錄',
              'en': 'Credit Record'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "moneyForDetails",
          component: () =>
            import("../pages/financialManagement/moneyForDetails"),
          meta: { 
            title: {
              'zh-CN': '公司佣金详情',
              'zh-TW': '公司佣金詳情',
              'en': 'Company Commission Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "partnerList",
          component: () => import("../pages/TurnToIntroduce/partnerList"),
          meta: { 
            title: {
              'zh-CN': '合作伙伴列表',
              'zh-TW': '合作夥伴列表',
              'en': 'Partner List'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "partnerListDetailList",
          component: () =>
            import("../pages/TurnToIntroduce/partnerListDetailList"),
          meta: { 
            title: {
              'zh-CN': '列表详情',
              'zh-TW': '列表詳情',
              'en': 'List Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "partnerListDetail",
          component: () => import("../pages/TurnToIntroduce/partnerListDetail"),
          meta: { 
            title: {
              'zh-CN': '合作伙伴详情',
              'zh-TW': '合作夥伴詳情',
              'en': 'Partner Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "rulesSetting",
          component: () => import("../pages/TurnToIntroduce/rulesSetting"),
          meta: { 
            title: {
              'zh-CN': '规则设置',
              'zh-TW': '規則設置',
              'en': 'Rules Setting'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "withdrawalList",
          component: () => import("../pages/TurnToIntroduce/withdrawalList"),
          meta: { 
            title: {
              'zh-CN': '赏金提现列表',
              'zh-TW': '賞金提現列表',
              'en': 'Reward Withdrawal List'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "agentManage",
          component: () => import("../pages/agentManage/agentManage"),
          meta: { 
            title: {
              'zh-CN': '代理企业',
              'zh-TW': '代理企業',
              'en': 'Agent Enterprise'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "companyDetail",
          component: () => import("../pages/agentManage/companyDetail"),
          meta: { 
            title: {
              'zh-CN': '代理企业详情',
              'zh-TW': '代理企業詳情',
              'en': 'Agent Company Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "personalCommissionDetall",
          component: () =>
            import("../pages/financialManagement/personalCommissionDetall"),
          meta: { 
            title: {
              'zh-CN': '个人佣金详情',
              'zh-TW': '個人佣金詳情',
              'en': 'Personal Commission Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "moneyForDetails",
          component: () =>
            import("../pages/financialManagement/moneyForDetails"),
          meta: { title: "公司佣金详情", keepAlive: false },
        },
        {
          path: "moneyManagement",
          component: () =>
            import("../pages/financialManagement/moneyManagement"),
          meta: { 
            title: {
              'zh-CN': '资金管理',
              'zh-TW': '資金管理',
              'en': 'Money Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "management",
          component: () => import("../pages/merchandiseManagement/management"),
          meta: { 
            title: {
              'zh-CN': '商品管理',
              'zh-TW': '商品管理',
              'en': 'Product Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "appointmentManagement",
          component: () =>
            import("../pages/merchandiseManagement/appointmentManagement"),
          meta: { 
            title: {
              'zh-CN': '预约管理',
              'zh-TW': '預約管理',
              'en': 'Appointment Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "freightManagement",
          component: () =>
            import("../pages/merchandiseManagement/freightManagement"),
          meta: { 
            title: {
              'zh-CN': '运费管理',
              'zh-TW': '運費管理',
              'en': 'Freight Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "distributionStatistics",
          component: () =>
            import(
              "../pages/marketingActivities/distribution/distributionStatistics"
            ),
          meta: { 
            title: {
              'zh-CN': '分销统计',
              'zh-TW': '分銷統計',
              'en': 'Distribution Statistics'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "personnelApplication",
          component: () =>
            import(
              "../pages/marketingActivities/distribution/personnelApplication"
            ),
          meta: { 
            title: {
              'zh-CN': '人员申请',
              'zh-TW': '人員申請',
              'en': 'Personnel Application'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "distributionLevel",
          component: () =>
            import(
              "../pages/marketingActivities/distribution/distributionLevel"
            ),
          meta: { 
            title: {
              'zh-CN': '分销等级',
              'zh-TW': '分銷等級',
              'en': 'Distribution Level'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "distributionOrder",
          component: () =>
            import(
              "../pages/marketingActivities/distribution/distributionOrder"
            ),
          meta: { 
            title: {
              'zh-CN': '分销订单',
              'zh-TW': '分銷訂單',
              'en': 'Distribution Order'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "accountTransfer",
          component: () =>
            import("../pages/marketingActivities/distribution/accountTransfer"),
          meta: { 
            title: {
              'zh-CN': '到账流水',
              'zh-TW': '到賬流水',
              'en': 'Account Transfer'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "productList",
          component: () =>
            import("../pages/marketingActivities/joinGroup/productList"),
          meta: { 
            title: {
              'zh-CN': '拼团商品列表',
              'zh-TW': '拼團商品列表',
              'en': 'Group Buy Product List'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "listParticipants",
          component: () =>
            import("../pages/marketingActivities/joinGroup/listParticipants"),
          meta: { 
            title: {
              'zh-CN': '参团列表',
              'zh-TW': '參團列表',
              'en': 'Participants List'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "assembleOrdersInfo",
          component: () =>
            import("../pages/marketingActivities/joinGroup/assembleOrdersInfo"),
          meta: { 
            title: {
              'zh-CN': '订单详情',
              'zh-TW': '訂單詳情',
              'en': 'Order Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "addAssemble",
          component: () =>
            import(
              "../pages/marketingActivities/joinGroup/components/addAssemble"
            ),
          meta: { 
            title: {
              'zh-CN': '拼团配置',
              'zh-TW': '拼團配置',
              'en': 'Group Buy Configuration'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "spikeList",
          component: () => import("../pages/marketingActivities/spike"),
          meta: { 
            title: {
              'zh-CN': '秒杀商品列表',
              'zh-TW': '秒殺商品列表',
              'en': 'Flash Sale Product List'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "addSpike",
          component: () =>
            import("../pages/marketingActivities/spike/components/addSpike"),
          meta: { 
            title: {
              'zh-CN': '秒杀设置',
              'zh-TW': '秒殺設置',
              'en': 'Flash Sale Settings'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "couponList",
          component: () =>
            import("../pages/marketingActivities/couponManagement/couponList"),
          meta: { 
            title: {
              'zh-CN': '优惠券列表',
              'zh-TW': '優惠券列表',
              'en': 'Coupon List'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "detailCoupon",
          component: () =>
            import(
              "../pages/marketingActivities/couponManagement/detailCoupon"
            ),
          meta: { 
            title: {
              'zh-CN': '领取详情',
              'zh-TW': '領取詳情',
              'en': 'Collection Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "customerArticles",
          component: () =>
            import("../pages/articleManagement/customerArticles"),
          meta: { 
            title: {
              'zh-CN': '获客文章',
              'zh-TW': '獲客文章',
              'en': 'Customer Acquisition Articles'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "isDrafts",
          component: () => import("../pages/articleManagement/isDrafts"),
          meta: { 
            title: {
              'zh-CN': '获客文章草稿箱',
              'zh-TW': '獲客文章草稿箱',
              'en': 'Customer Articles Drafts'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "employeeData",
          component: () => import("../pages/articleManagement/employeeData"),
          meta: { 
            title: {
              'zh-CN': '员工数据',
              'zh-TW': '員工數據',
              'en': 'Employee Data'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "staffDataDetail",
          component: () =>
            import("../pages/articleManagement/components/staffDataDetail"),
          meta: { 
            title: {
              'zh-CN': '员工数据',
              'zh-TW': '員工數據',
              'en': 'Employee Data'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "visitorData",
          component: () => import("../pages/articleManagement/visitorData"),
          meta: { 
            title: {
              'zh-CN': '访客数据',
              'zh-TW': '訪客數據',
              'en': 'Visitor Data'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "activityRegistration",
          component: () =>
            import("../pages/articleManagement/activityRegistration"),
          meta: { 
            title: {
              'zh-CN': '活动报名管理',
              'zh-TW': '活動報名管理',
              'en': 'Activity Registration Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "addActivity",
          component: () => import("../pages/articleManagement/addActivity"),
          meta: { 
            title: {
              'zh-CN': '新增活动',
              'zh-TW': '新增活動',
              'en': 'Add New Activity'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "activityDetails",
          component: () => import("../pages/articleManagement/activityDetails"),
          meta: { 
            title: {
              'zh-CN': '活动详情',
              'zh-TW': '活動詳情',
              'en': 'Activity Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "dynamicBasicSetting",
          component: () =>
            import("../pages/articleManagement/dynamicBasicSetting"),
          meta: { 
            title: {
              'zh-CN': '基础设置',
              'zh-TW': '基礎設置',
              'en': 'Basic Settings'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "videoManage",
          component: () => import("../pages/videoManage"),
          meta: { 
            title: {
              'zh-CN': '短视频管理',
              'zh-TW': '短視頻管理',
              'en': 'Video Management'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "myNeeds",
          component: () => import("../pages/addedServices/myNeeds"),
          meta: { 
            title: {
              'zh-CN': '我的需求',
              'zh-TW': '我的需求',
              'en': 'My Needs'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "demandCheck",
          component: () => import("../pages/addedServices/demandCheck"),
          meta: { 
            title: {
              'zh-CN': '需求审核',
              'zh-TW': '需求審核',
              'en': 'Demand Review'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "demandContactsCheck",
          component: () => import("../pages/addedServices/demandContactsCheck"),
          meta: { 
            title: {
              'zh-CN': '人脉集市审核',
              'zh-TW': '人脈集市審核',
              'en': 'Contacts Market Review'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "demandProtuctsCheck",
          component: () => import("../pages/addedServices/demandProtuctsCheck"),
          meta: { 
            title: {
              'zh-CN': '产品中心审核',
              'zh-TW': '產品中心審核',
              'en': 'Product Center Review'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "demandPublishSetting",
          component: () =>
            import("../pages/addedServices/demandPublishSetting"),
          meta: { 
            title: {
              'zh-CN': '发布设置',
              'zh-TW': '發布設置',
              'en': 'Publish Settings'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "demandReport",
          component: () => import("../pages/addedServices/demandReport"),
          meta: { 
            title: {
              'zh-CN': '举报处理',
              'zh-TW': '舉報處理',
              'en': 'Report Handling'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "demandCustomize",
          component: () => import("../pages/addedServices/demandCustomize"),
          meta: { 
            title: {
              'zh-CN': '自定义设置',
              'zh-TW': '自定義設置',
              'en': 'Custom Settings'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "demandPublishForm",
          component: () =>
            import("../pages/addedServices/components/demandPublishForm"),
          meta: { 
            title: {
              'zh-CN': '发布需求',
              'zh-TW': '發布需求',
              'en': 'Publish Demand'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "posterAtlas",
          component: () =>
            import("../pages/addedServices/sharingPromotion/posterAtlas"),
          meta: { 
            title: {
              'zh-CN': '海报图集',
              'zh-TW': '海報圖集',
              'en': 'Poster Atlas'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "posterAtlasDetall",
          component: () =>
            import("../pages/addedServices/sharingPromotion/posterAtlasDetall"),
          meta: { 
            title: {
              'zh-CN': '海报图集详情',
              'zh-TW': '海報圖集詳情',
              'en': 'Poster Atlas Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "clockData",
          component: () => import("../pages/addedServices/clockData"),
          meta: { 
            title: {
              'zh-CN': '打卡数据',
              'zh-TW': '打卡數據',
              'en': 'Clock Data'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "clockDataDetall",
          component: () =>
            import("../pages/addedServices/clockData/clockDataDetall"),
          meta: { 
            title: {
              'zh-CN': '打卡详情',
              'zh-TW': '打卡詳情',
              'en': 'Clock Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "appletConfig",
          component: () => import("../pages/miniProgram/appletConfig"),
          meta: { 
            title: {
              'zh-CN': '小程序配置',
              'zh-TW': '小程序配置',
              'en': 'Mini Program Configuration'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "basicSetting",
          component: () => import("../pages/miniProgram/basicSetting"),
          meta: {
            title: {
              'zh-CN': '基础设置',
              'zh-TW': '基礎設置',
              'en': 'Basic Settings'
            },
            keepAlive: false,
          },
        },
        // {
        // 	path:'miniProgram',
        // 	component: () => import('../pages/miniProgram'),
        // 	meta: { title: '小程序配置' }
        // },
        {
          path: "mallSetting",
          component: () => import("../pages/miniProgram/mallSetting"),
          meta: { 
            title: {
              'zh-CN': '商城设置',
              'zh-TW': '商城設置',
              'en': 'Mall Settings'
            }, 
            keepAlive: true 
          },
        },
        // {
        // 	path:'mallTemplate',
        // 	component: () => import('../pages/miniProgram/mallTemplate'),
        // 	meta: { title: '商城模板设置',keepAlive: false }
        // },
        {
          path: "templateA",
          component: () => import("../pages/miniProgram/templateA"),
          meta: { 
            title: {
              'zh-CN': '综合电商',
              'zh-TW': '綜合電商',
              'en': 'Comprehensive E-commerce'
            }, 
            keepAlive: true 
          },
        },
        {
          path: "templateB",
          component: () => import("../pages/miniProgram/templateB"),
          meta: { 
            title: {
              'zh-CN': '节日优惠',
              'zh-TW': '節日優惠',
              'en': 'Festival Offers'
            }, 
            keepAlive: true 
          },
        },
        {
          path: "templateC",
          component: () => import("../pages/miniProgram/templateC"),
          meta: { 
            title: {
              'zh-CN': '日用百货',
              'zh-TW': '日用百貨',
              'en': 'Daily Necessities'
            }, 
            keepAlive: true 
          },
        },
        {
          path: "templateD",
          component: () => import("../pages/miniProgram/templateD"),
          meta: { 
            title: {
              'zh-CN': '数码家电',
              'zh-TW': '數碼家電',
              'en': 'Digital & Home Appliances'
            }, 
            keepAlive: true 
          },
        },
        {
          path: "goodsDetails",
          component: () =>
            import("../pages/merchandiseManagement/goodsDetails"),
          meta: { 
            title: {
              'zh-CN': '商品详情',
              'zh-TW': '商品詳情',
              'en': 'Product Details'
            }, 
            keepAlive: false 
          },
        },
        {
          path: "redactOrAdd",
          component: () => import("../pages/merchandiseManagement/redactOrAdd"),
          meta: { 
            title: {
              'zh-CN': '商品发布',
              'zh-TW': '商品發布',
              'en': 'Product Publishing'
            }, 
            keepAlive: false 
          },
        },
      ],
    },
    {
      path: "/login",
      component: () => import("../pages/login"),
      meta: { 
        title: {
          'zh-CN': '登录',
          'zh-TW': '登錄',
          'en': 'Login'
        } 
      },
    },
    {
      path: "*",
      redirect: "/dashboard",
    },
  ],
});
